const customNode_entireEra = {
  start_earliest: "1750-01-01",
  start_latest: "1750-01-01",
  end_earliest: "1889-12-31",
  end_latest: "1889-12-31",
};

function getSplitDate(str) {
  const arr = str.split("-");
  return [parseInt(arr[0]), parseInt(arr[1]), parseInt(arr[2])];
}

function extractFromDate(node, format, orientation, tendency) {
  let formatIndex;
  switch (format) {
    case "day":
      formatIndex = 2;
      break;
    case "month":
      formatIndex = 1;
      break;
    case "year":
      formatIndex = 0;
      break;
    default:
      console.log("extractFromDate format parameter unreadable");
  }

  if (orientation == "start") {
    if (tendency == "earliest")
      return parseInt(node.start_earliest.split("-")[formatIndex]);
    else if (tendency == "latest")
      return parseInt(node.start_latest.split("-")[formatIndex]);
    else console.log("extractFromDate tendency parameter unreadable");
  } else if (orientation == "end") {
    if (tendency == "earliest")
      return parseInt(node.end_earliest.split("-")[formatIndex]);
    else if (tendency == "latest")
      return parseInt(node.end_latest.split("-")[formatIndex]);
    else console.log("extractFromDate tendency parameter unreadable");
  } else console.log("extractFromDate orientation parameter unreadable");
}

function getMonthLength(month, year) {
  if (year == null || year == undefined) {
    year = 2020;
    console.log(
      "used year 2020 for getMonthLength because parameter year was not usable",
    );
  }
  return new Date(year, month, 0).getDate();
}

function getPeriodLength(first, second) {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const firstDate = new Date(first[0], first[1], first[2]);
  const secondDate = new Date(second[0], second[1], second[2]);
  return Math.round((firstDate - secondDate) / oneDay);
}

function getPreviousMonthsLength(month, year) {
  year == null && console.log("year is undefined");
  let result;
  switch (month) {
    case 1:
      result = 0;
      break;
    case 2:
      result = getMonthLength(1, year);
      break;
    case 3:
      result = getMonthLength(1, year) + getMonthLength(2, year);
      break;
    case 4:
      result = 0;
      break;
    case 5:
      result = getMonthLength(4, year);
      break;
    case 6:
      result = getMonthLength(4, year) + getMonthLength(5, year);
      break;
    case 7:
      result = 0;
      break;
    case 8:
      result = getMonthLength(7, year);
      break;
    case 9:
      result = getMonthLength(7, year) + getMonthLength(8, year);
      break;
    case 10:
      result = 0;
      break;
    case 11:
      result = getMonthLength(10, year);
      break;
    case 12:
      result = getMonthLength(10, year) + getMonthLength(11, year);
      break;
  }
  return parseInt(result);
}

function monthDiff(d1, d2) {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

function quartalsSinceEraStart(date) {
  const year = parseInt(date.split("-")[0]);
  const yearsInQuarters =
    (year - extractFromDate(customNode_entireEra, "year", "start", "earliest")) * 4;
  const month = date.split("-")[1];
  const quarter = Math.ceil(month / 3) == 0 ? 1 : Math.ceil(month / 3);
  return Math.abs(yearsInQuarters) + Math.abs(quarter);
}

export default {
  customNode_entireEra,
  getSplitDate,
  extractFromDate,
  getMonthLength,
  getPeriodLength,
  getPreviousMonthsLength,
  monthDiff,
  quartalsSinceEraStart,
};
